import { render } from "./f1Vegas.vue?vue&type=template&id=42515dc6"
import script from "./f1Vegas.vue?vue&type=script&lang=js"
export * from "./f1Vegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__